import projImg1 from "../assets/img/project-img1.webp";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.webp";
import projImg4 from "../assets/img/project-img1.jpeg";
import projImg5 from "../assets/img/project-img5.jpg";
import projImg6 from "../assets/img/project-img6.png";
import projImg7 from "../assets/img/project-img7.png";
import projImg8 from "../assets/img/project-img8.webp";
import projImg9 from "../assets/img/project-img9.png";
import projImg10 from "../assets/img/project-img10.webp";
import projImg11 from "../assets/img/project-img11.webp";

import sysImg1 from "../assets/img/systems_img1.jpg";
import sysImg2 from "../assets/img/systems_img2.jpg";

import roboImg1 from "../assets/img/robo-img1.webp";
import roboImg2 from "../assets/img/robo-img2.webp";
import roboImg3 from "../assets/img/robo-img3.webp";
import roboImg4 from "../assets/img/robo-img4.webp";
import roboImg5 from "../assets/img/robo-img5.webp";
import roboImg6 from "../assets/img/robo-img6.webp";

import postImg1 from "../assets/img/post-img1.png";
import postImg2 from "../assets/img/post-img2.png";
import postImg3 from "../assets/img/post-img3.png";
import postImg4 from "../assets/img/post-img4.png";
import postImg5 from "../assets/img/post-img5.png";

import placeholderImg from "../assets/img/image.webp";

import cardEmbedded from "../assets/hero/card-embedded.webp";
import cardCrypto from "../assets/hero/card-crypto.webp";
import cardRobotics from "../assets/hero/card-robotics.webp";
import cardBlockchain from "../assets/hero/card-blockchain.webp";

const imageMap = {
  cardEmbedded,
  cardCrypto,
  cardRobotics,
  cardBlockchain,
  proj1: projImg1,
  proj2: projImg2,
  proj3: projImg3,
  proj4: projImg4,
  proj5: projImg5,
  proj6: projImg6,
  proj7: projImg7,
  proj8: projImg8,
  proj9: projImg9,
  proj10: projImg10,
  proj11: projImg11,
  sys1: sysImg1,
  sys2: sysImg2,
  robo1: roboImg1,
  robo2: roboImg2,
  robo3: roboImg3,
  robo4: roboImg4,
  robo5: roboImg5,
  robo6: roboImg6,
  post1: postImg1,
  post2: postImg2,
  post3: postImg3,
  post4: postImg4,
  post5: postImg5,
};

export const getImageByKey = (imageKey) => imageMap[imageKey] || placeholderImg;

export { placeholderImg };
